export default "__VITE_ASSET__oLqUhFib__"